import { Injectable, OnInit, Predicate } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Person } from '../models/index';
import { PeopleDataService } from './peopleData.service';
import * as _ from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class PeopleService {
  people: Person[] = [];
  public person: Person;

  public selectedPeopleToEdit = new BehaviorSubject([]);

  constructor(private dataService: PeopleDataService) {}

  public getPerson(id: string): Observable<Person> {
    return this.dataService.getPerson(id);
  }

  public getPeopleToEdit() {
    return this.selectedPeopleToEdit.asObservable();
  }

  public setPeopleToEdit(people) {
    this.selectedPeopleToEdit.next(people);
  }

  public getCurrent(): Observable<Person> {
    return this.dataService.getCurrent();
  }

  public getPeople(): Observable<Person[]> {
    return this.dataService.getPeople();
  }

  public updateCurrentPerson(id: string, params: any): Observable<Person> {
    return this.dataService.updateCurrentPerson(id, params);
  }

  public addPerson(params: any): Observable<Person> {
    return this.dataService.addPerson(params);
  }

  public getPermissions(): Observable<any> {
    return this.dataService.getPermissions();
  }

  public getPersonLanguage(): Observable<any> {
    return this.dataService.getPersonLanguage();
  }

  public getCurrentScopePeople(): Observable<Person[]> {
    return this.dataService.getCurrentScopePeople();
  }

  updatePerson(id: string, params: any): Observable<Person> {
    return this.dataService.managePerson(id, params);
  }

  public updatePeople(params: any): Observable<Person[]> {
    return this.dataService.updatePeople(params);
  }

  deletePerson(id: string): Observable<any> {
    return this.dataService.deletePerson(id);
  }

  public deletePeople(peopleToDelete: string[]){
    return this.dataService.deletePeople(peopleToDelete);
  }

  public logout() {
    this.dataService.setCurrent(null);
  }

  getValue(value: any, array: any): string {
    const obj = _.find(array, ['value', value]);
    return obj ? obj.label : '';
  }

  setPerson(person: Person): void {
    this.person = person;
  }

  public getPersonEntity(personId: string): Observable<any> {
    return this.dataService.getPersonEntity(personId);
  }

  public updatePersonEntity(personId: string, person: any): Observable<any> {
    return this.dataService.updatePersonEntity(personId, person);
  }
}
